export interface IUser {
    userId: number;
    firstName: string;
    encryptedUserId: string;
    middleName: string;
    lastName: string;
    fullName: string;
    email: string;
    mobile: string;
    countryId: number;
    locationId: number;
    locationName: string;
    roleId: number;
    countryName: string;
    countryCode: string;
    isoCode: string;
    providerLocationId: number;
    gender: string;
    dateOfBirth?: Date;
    profileImageUrl: string;
    thumbnailUrl: string;
    base64ProfileImage: string;
    active: boolean;
    isLocked: boolean;
    practiceName: string;
    providerLocation: string;
    providerName: string;
    createdBy: number;
    createdDate: Date;
    modifiedBy?: number;
    modifiedDate?: Date;
    totalItems: number;
    isOnline: boolean;
    retailIds: string;
    locationNames: string;
    locationIdentifiers: string;
    userName: string;
    excelDownload?: boolean;
    restrictUserLogin?: boolean;
    financeBackground?: boolean;
    addressLine?: string;
    employeeCode?: string;
    accountId?: number;
    signature?: string;
    base64Signature?: string;
    createdByRole: string;
    modifiedByRole: string;
    pharmacyWareHouseIds: string;
    pharmacyDepartmentIds: string;
    retailPharmacyIds: string;
    departmentIds: number[];
    departmentName: string;
    departmentIdsList: string;
    ipConfig: string;
    wareHouseIds: string;
    pharmacyDepatIds: string;
    financialInfo: string;
    medRegistration: string;
    personalInfo: string;
    educationalDetails: string;


}